
import * as storyblokRuntime$srq2sd9UxsPZyFYkE9UY1ht9WsYCo007KG0L9k3vycE from '/codebuild/output/src2900687957/src/ark/node_modules/@nuxt/image/dist/runtime/providers/storyblok'
import * as awsAmplifyRuntime$CDLAuHcxvEg7gCPw0qhumWvZUfuQVdc6G8mCaSkpnFQ from '/codebuild/output/src2900687957/src/ark/node_modules/@nuxt/image/dist/runtime/providers/awsAmplify'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "awsAmplify",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['storyblok']: { provider: storyblokRuntime$srq2sd9UxsPZyFYkE9UY1ht9WsYCo007KG0L9k3vycE, defaults: {"baseURL":"https://a.storyblok.com"} },
  ['awsAmplify']: { provider: awsAmplifyRuntime$CDLAuHcxvEg7gCPw0qhumWvZUfuQVdc6G8mCaSkpnFQ, defaults: {} }
}
        